import { html } from 'lit';
import '../../library/elements/d-action.js';
import '../../library/elements/d-section.js';
import '../../library/editors/elements/d-edit-textarea.js';
import { customElement, property } from 'lit/decorators.js';
import { BaseDialog } from 'src/library/components/BaseDialog.js';
import { t } from 'src/i18n';
import type { FeedbackInput } from './feedback-input';
import type { FeedbackResult } from './feedback-result';
import type { DialogActionInput } from 'src/library/components/DialogActionInput';

/**
 *
 * STATUS OK
 */
@customElement('d-feedback-dialog')
export class DFeedbackDialog extends BaseDialog<FeedbackInput, FeedbackResult> {
  @property({ type: Boolean })
  sending = false;
  @property({ type: String })
  message = '';
  width = 600;
  title = t('layout.feedback.title');

  protected get calculatedFooterActions(): DialogActionInput[] {
    return [
      { name: t('common:cancel'), action: 'cancel' },
      { name: t('layout.send'), action: 'send', main: true, disabled: this.noMessage },
    ];
  }

  private get noMessage() {
    return this.message === undefined || this.message.trim() === '';
  }

  renderBody() {
    return html`
      <d-section topless>
        <d-edit-textarea
          max-rows="50"
          placeholder="${t('layout.feedback.placeholder')}"
          .value=${this.message}
          autofocus
          @value-changed=${this.onMessageChanged}
        ></d-edit-textarea>
      </d-section>
    `;
  }

  protected fetchResult(detail: string | undefined): FeedbackResult {
    return {
      message: detail === 'send' ? this.message : '',
      action: detail === 'send' ? 'done' : 'cancel',
    };
  }

  protected initializeDialog(input: FeedbackInput) {
    this.message = input.message;
  }

  /**
   * Update message when value is changed
   * @param {CustomEvent} e Custom Event
   */
  private onMessageChanged(e: CustomEvent) {
    this.message = e.detail.value;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'd-feedback-dialog': DFeedbackDialog;
  }
}
